<template>
  <div class="webscrapingapi-section">
    <div class="mx-4 mb-3">
      <v-row class="mb-4">
        <v-col lg="6" md="12" cols="12">
          <v-card class="d-flex flex-column">
            <v-card-title class="xlg--text fontweight400 pt-6">
              Current subscription</v-card-title
            >
            <v-card-text
                class="text--primary flex-grow-1 d-flex flex-column"
                v-if="!!subscription && !!subscription.plan"
                height="100%"
            >
              <div>
                <p class="fontlight--text xs--text">
                  Current plan:
                  <router-link
                      class="text-decoration router-link"
                      to="/subscriptions"
                  ><b>{{ subscription.plan.name }}</b></router-link
                  >
                </p>
                <p class="fontlight--text xs--text">
                  Start date:
                  <b>{{ getUTCDateString(subscription.start_time) }}</b>
                </p>
                <p class="fontlight--text xs--text">
                  Renewal date:
                  <b>{{ getUTCDateString(subscription.end_time) }}</b>
                </p>
                <p class="fontlight--text xs--text">
                  Restart the subscription when running out of API credits:
                  <b>{{ api_renew_status ? 'Enabled' : 'Disabled' }}</b>
                </p>
                <p class="fontlight--text xs--text">
                  API token:
                  <b>{{ api_token }}</b>
                </p>
              </div>
              <v-spacer></v-spacer>
              <div>
                <v-progress-linear
                    color="primary"
                    height="20"
                    :value="usageValue"
                    striped
                >
                  <template v-slot:default="{ value }">
                    <strong>{{ Math.round(value * 100) / 100 }}%</strong>
                  </template>
                </v-progress-linear>
                <p class="fontlight--text xs--text">
                  You have consumed
                  <b>{{
                      (subscription.total_credits -
                          subscription.remained_credits).toLocaleString()
                    }}</b>
                  of <b>{{ subscription.total_credits.toLocaleString() }}</b> available API
                  credits
                </p>
                <p
                    class="fontlight--text xs--text"
                    v-if="subscription.remained_credits === 0"
                >
                  You've run out of API credits in the current subscription.
                  Please, visit
                  <router-link
                      class="text-decoration router-link"
                      to="/subscriptions"
                  >Subscriptions</router-link
                  >
                  to Upgrade your plan or
                  <a
                      class="text-decoration router-link"
                      href="mailto:support@scrapingant.com"
                  >Contact Us</a
                  >
                  to discuss a custom plan.
                </p>
              </div>
            </v-card-text>
            <v-card-text v-else>
              <p class="fontlight--text xs--text">
                No active subscription. Please,
                <a class="text-decoration router-link" @click="reload"
                >reload</a
                >
                page or try again later.
              </p>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col lg="6" md="12" cols="12">
          <v-row class="ma-0">
            <v-col class="pa-0 mb-6" cols="12">
              <v-card>
                <v-card-title class="">
                  <v-icon class="mr-2" :color="doc_icon">{{ doc_icon }}</v-icon>
                  {{ doc_title }}</v-card-title>
                <v-card-text>
                  <p class="fontlight--text xs--text">
                    {{ doc_content }}
                  </p>
                </v-card-text>
                <v-card-actions class="justify-end">
                  <v-btn text class="fontweight400" target="_blank"
                         href="https://docs.scrapingant.com">
                    Follow the docs
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
            <v-col
                class="pa-0 mb-6"
                cols="12"
                v-if="subscription && subscription.update_url"
            >
              <v-card>
                <v-card-title class="xlg--text fontweight400 pt-6">
                  Subscription restart settings
                </v-card-title>
                <v-card-text>
                  <p class="fontlight--text xs--text">
                    This setting allows you to restart the subscription when you run out of API credits.
                  </p>
                  <p class="fontlight--text xs--text">
                    Current status: <b>{{ api_renew_status ? 'Enabled' : 'Disabled' }}</b>
                  </p>
                </v-card-text>
                <v-card-actions class="justify-end">
                  <v-btn
                      text
                      class="fontweight400"
                      @click="onChangeRenewStatusClicked"
                  >
                    {{ api_renew_status ? 'Disable' : 'Enable' }} restart
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
            <v-col
                class="pa-0 mb-6"
                cols="12"
                v-if="subscription && subscription.update_url"
            >
              <v-card>
                <v-card-title class="xlg--text fontweight400 pt-6">
                  Payment details
                </v-card-title>
                <v-card-text>
                  <p class="fontlight--text xs--text">
                    Change and update payment details
                  </p>
                </v-card-text>
                <v-card-actions class="justify-end">
                  <v-btn
                      text
                      class="fontweight400"
                      @click="onUpdatePaymentDetailsClicked"
                  >
                    Update payment
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>

    <div class="mx-4 mb-10 custom-requesgenerator">
      <v-card>
        <v-card-title class="xlg--text fontweight400 pt-6"
        >Request generator</v-card-title
        >
        <v-card-text>
          <div>
            <v-row>
              <v-col lg="6" md="12" cols="12">
                <div>
                  <v-text-field
                      hide-details
                      label="URL"
                      v-model="request_generator.url"
                      required
                  ></v-text-field>
                  <div v-if="request_generator.response_type === 'extract'">
                    <v-text-field
                        hide-details
                        label="Extract properties"
                        v-model="request_generator.extract_properties"
                        required
                        class="mt-3"
                    ></v-text-field>
                  </div>
                  <div>
                    <v-row class="mt-0">
                      <v-col>
                        <v-select
                            :items="proxytype"
                            label="Proxy type"
                            item-text="name"
                            item-value="value"
                            v-model="request_generator.proxy_type"
                            id="proxy_type"
                        ></v-select>
                      </v-col>
                      <v-col>
                        <v-select
                            :items="proxycountry"
                            label="Proxy country"
                            item-text="name"
                            item-value="value"
                            v-model="request_generator.country"
                            id="country"
                        ></v-select>
                      </v-col>
                      <v-col class="d-flex align-center">
                        <v-select
                            :items="response_types"
                            label="Extraction type"
                            item-text="name"
                            item-value="value"
                            v-model="request_generator.response_type"
                            id="response_type"
                        ></v-select>
                        </v-col>
                    </v-row>
                  </div>
                  <div>
                    <v-row class="mb-3">
                      <v-col class="d-flex align-center">
                        <v-switch
                            v-model="request_generator.browser"
                            color="primary"
                            class="mt-0 mr-3"
                            hide-details
                        >
                        </v-switch>

                        <span class="xs--text fontlight--text mr-3 opacity-80"
                        >Use headless browser</span
                        >

                        <v-tooltip right>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                                color="fontlight"
                                dark
                                class="opacity-50"
                                v-bind="attrs"
                                v-on="on"
                            >
                              mdi-help-circle
                            </v-icon>
                          </template>
                          <span class="xxs--text"
                          >Enables headless browser for making the request</span
                          >
                        </v-tooltip>
                      </v-col>
                      <v-col class="d-flex align-center">
                        <v-switch
                            v-model="request_generator.return_page_source"
                            color="primary"
                            class="mt-0 mr-3"
                            :disabled="!request_generator.browser"
                            hide-details
                        >
                        </v-switch>

                        <span class="xs--text fontlight--text mr-3 opacity-80">Return page source</span>

                        <v-tooltip right>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                                color="fontlight"
                                dark
                                class="opacity-50"
                                v-bind="attrs"
                                v-on="on"
                            >
                              mdi-help-circle
                            </v-icon>
                          </template>
                          <span class="xxs--text">
                          Enables returning original HTML of the web page
                          (applicable to the browser rendering only)</span>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                  </div>
                  <div class="mb-3">
                    <v-textarea
                        outlined
                        text
                        label="Cookies"
                        class="custom-textarea"
                        height="120"
                        hide-details
                        v-model="request_generator.cookies"
                    ></v-textarea>
                    <span class="xxs--text">
                      Format:
                      cookie_name_1=cookie_value_1;cookie_name_2=cookie_value_2
                      <a
                          class="text-decoration router-link"
                          target="_blank"
                          href="https://docs.scrapingant.com/custom-cookies"
                      >Learn more</a
                      >
                    </span>
                  </div>

                  <div class="mb-3">
                    <v-textarea
                        outlined
                        text
                        label="JS snippet"
                        height="120"
                        class="custom-textarea"
                        hide-details
                        v-model="request_generator.js_snippet"
                        :disabled="!request_generator.browser"
                    ></v-textarea>
                    <span class="xxs--text">
                      JS snippet to run inside scraping page after the page
                      load. (applicable to the browser rendering only)
                      <a
                          class="text-decoration router-link"
                          target="_blank"
                          href="https://docs.scrapingant.com/javascript-execution"
                      >Learn more</a
                      >
                    </span>
                  </div>

                  <div class="mb-5">
                    <v-textarea
                        outlined
                        text
                        label="Wait for CSS selector"
                        class="custom-textarea"
                        height="120"
                        hide-details
                        v-model="request_generator.wait_for_selector"
                        :disabled="!request_generator.browser"
                    ></v-textarea>
                    <span class="xxs--text">
                      CSS selector of the DOM element to wait before returning
                      the result. (applicable to the browser rendering only)
                      <a
                          class="text-decoration router-link"
                          target="_blank"
                          href="https://docs.scrapingant.com/wait-for-selector"
                      >Learn more</a
                      >
                    </span>
                  </div>

                  <div class="mb-3">
                    <v-row align="center">
                      <v-col>
                        <span v-if="request_generator.response_type === 'extract'" class="xs--text fontlight--text opacity-100">
                          Extract cost is available after request
                        </span>
                        <span v-else class="xs--text fontlight--text opacity-100"
                        >Request cost: {{ requestCost }} API credits</span
                        >
                      </v-col>
                      <v-col class="text-right">
                        <v-btn
                            color="primary"
                            :disabled="!request_generator.url"
                            @click="executeRequestClicked"
                        >
                          <span class="fontlight--text fontweight400">Execute request</span>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </div>
                </div>
              </v-col>
              <v-col lg="6" md="12" cols="12">
                <div>
                  <v-tabs v-model="tab">
                    <v-tab
                        class="fontweight400"
                        v-for="item in tabItems"
                        :key="item"
                    >
                      {{ item }}
                    </v-tab>
                  </v-tabs>

                  <v-tabs-items v-model="tab">
                    <v-tab-item v-for="(item, index) in tabItems" :key="item">
                      <h3 v-if="tabItems[tab] !== 'proxy'" class="pt-6 fontlight--text">GET request example</h3>
                      <h3 v-else class="pt-6 fontlight--text">Proxy credentials</h3>
                      <prism
                          :language="templates[index].prism_language"
                          :code="templates[index].get_template"
                      ></prism>
                      <v-row>
                        <v-col class="text-end">
                          <v-btn
                              text
                              v-clipboard:success="onCopiedToClipboard"
                              v-clipboard="() => templates[index].get_template"
                          >Copy to clipboard
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-tab-item>
                  </v-tabs-items>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-card-text>
      </v-card>
    </div>
    <div class="mx-4 mb-4">
      <v-card>
        <v-card-title> <div class="md-title">Usage chart</div></v-card-title>
        <v-card-text>
          <v-progress-circular
              v-if="usage_grapph_loading"
              :size="50"
              :width="2"
              color="primary"
              indeterminate
          ></v-progress-circular>
          <usage-chart v-if="!usage_grapph_loading"
                       :start-date="getUTCDateString(subscription.start_time)"
                       :chart-data="chartdata"
          /> </v-card-text
        >
      </v-card>
    </div>

    <!--    <div class="text-center">-->
    <v-dialog v-model="show_result_dialog" scrollable width="800" style='min-height: 40%'>
      <v-card>
        <v-card-title class="fontweight400"> Request result </v-card-title>

        <v-card-text>
          <prism
              v-if="!!request_dialog_result"
              :language="typeof raw_result === 'object' ? 'json' : 'html'"
              :code="request_dialog_result"
          ></prism>
          <div v-else class="execution-notice">
            <h3>Request execution time might be up to 60 seconds</h3>
          </div>
          <p v-if="request_dialog_result">Request cost: {{ request_cost }} API credits</p>
          <div v-if="result_loading" class="execution-spinner">
            <v-progress-circular
                :size="50"
                :width="2"
                color="primary"
                indeterminate
            ></v-progress-circular>
          </div>
        </v-card-text>

        <v-card-actions>
          <RequestFeedback :generator-data="request_generator" />
          <Filler />
          <v-spacer></v-spacer>

          <v-btn
              text
              :disabled="!request_dialog_result"
              @click="clipboardForOutput(raw_result)"
          >
            Copy to clipboard
          </v-btn>
          <v-btn @click="show_result_dialog = false" text> Close </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--    </div>-->

    <div class="loading-overlay" v-if="loading">
      <v-progress-circular
          :size="50"
          :width="2"
          color="primary"
          indeterminate
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import UsageChart from "../views/UsageChart";
import Prism from "vue-prismjs";
import "prismjs/themes/prism.css";
import templates from "@/helper/languages_templates_helper";
import getDateUTCString from "@/utils/date_utils";
import constants from "@/config/constants";
import RequestFeedback from "@/views/RequestFeedback";
import Filler from "@/views/Filler";
import { getRequestCost } from "@/helper/request_price_helper";

export default {
  name: "WebScrapingAPI",
  components: { Filler, RequestFeedback, UsageChart, Prism },
  watch: {
    'request_generator.browser'(val) {
      if (val === false) {
        this.request_generator.wait_for_selector = "";
        this.request_generator.js_snippet = "";
        this.request_generator.return_page_source = false;
      }
    }
  },
  data() {
    return {
      tab: null,
      tabItems: ["curl", "python", "nodejs", "proxy"],
      text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      proxytype: [
        { name: "Standard", value: "datacenter" },
        { name: "Residential", value: "residential" }
      ],
      response_types: [
        {
          name: "Original",
          value: "general",
        },
        {
          name: "JSON (extended data)",
          value: "extended",
        },
        {
          name: "Markdown",
          value: "markdown",
        },
        {
          name: "AI extracted",
          value: "extract",
        }
      ],
      proxycountry: [
        { name: "All countries", value: "ALL" },
        { name: "USA", value: "US" },
        { name: "United Arab Emirates", value: "AE" },
        { name: "Brazil", value: "BR" },
        { name: "Canada", value: "CA"},
        { name: "China", value: "CN" },
        { name: "Czech Republic", value: "CZ" },
        { name: "Germany", value: "DE" },
        { name: "Spain", value: "ES" },
        { name: "France", value: "FR" },
        { name: "United Kingdom", value: "GB" },
        { name: "Hong Kong", value: "HK" },
        { name: "India", value: "IN" },
        { name: "Italy", value: "IT" },
        { name: "Israel", value: "IL" },
        { name: "Japan", value: "JP" },
        { name: "Netherlands", value: "NL" },
        { name: "Poland", value: "PL" },
        { name: "Russia", value: "RU" },
        { name: "Saudi Arabia", value: "SA" },
        { name: "Singapore", value: "SG" },
        { name: "South Korea", value: "KR" },
        { name: "Indonesia", value: "ID" },
        { name: "Vietnam", value: "VN" },
      ],
      dialog: false,
      request_generator: {
        url: constants.DEFAULT_REQUEST_GENERATOR_SITE,
        return_page_source: false,
        js_snippet: "",
        extract_properties: "title, content",
        cookies: "",
        country: "ALL",
        wait_for_selector: "",
        proxy_type: "datacenter",
        browser: true,
        response_type: "general"
      },
      api_token: "",
      show_result_dialog: false,
      request_dialog_result: "",
      raw_result: "",
      request_cost: 0,
      subscription: {},
      api_renew_status: false,
      chartdata: {
        labels: [],
        datasets: [
          {
            label: "API credits usage",
            lineTension: 0.2,
            borderWidth: 2,
            pointRadius: 2,
            backgroundColor: "#FFFFFF00",
            borderColor: "#E2782F",
            pointBorderColor: "#E2782F",
            pointBackgroundColor: "#E2782F",
            data: [],
          },
        ],
      },
      loading: false,
      result_loading: false,
      usage_grapph_loading: false,
      doc_title: "API Documentation",
      doc_icon: 'mdi-help-circle-outline',
      doc_content: 'Make sure not to miss our new features by reading docs!',
    };
  },
  computed: {
    usageValue() {
      return this.subscription
          ? (1 - parseFloat(this.subscription.remained_credits) / parseFloat(this.subscription.total_credits)) * 100
          : 0;
    },
    templates() {
      return [
        {
          name: "curl",
          get_template: templates.CURL.get(
              this.request_generator,
              this.api_token
          ),
          prism_language: "bash",
        },
        {
          name: "python",
          get_template: templates.PYTHON.get(
              this.request_generator,
              this.api_token
          ),
          prism_language: "python",
        },
        {
          name: "nodejs",
          get_template: templates.NODE_JS.get(
              this.request_generator,
              this.api_token
          ),
          prism_language: "javascript",
        },
        {
          name: "proxy",
          get_template: templates.PROXY.get(
              this.request_generator,
              this.api_token
          ),
          prism_language: "bash",
        }
      ];
    },
    requestCost() {
      return getRequestCost(this.request_generator);
    },
  },
  methods: {
    getToken() {
      return this.$store.dispatch("dashboard/getApiToken").then(
          (res) => {
            this.api_token = res.data.token;
          },
          (err) => {
            console.log(err);
          }
      );
    },

    getUsageGraph() {
      this.usage_grapph_loading = true;
      return this.$store.dispatch("dashboard/getUsageGraph").then((res) => {
        this.usage_grapph_loading = false;
        const newChartData = Object.assign({}, this.chartdata);
        newChartData.labels = res.data.labels;
        newChartData.datasets[0] = {
          label: 'API credits usage',
          lineTension: 0.2,
          borderWidth: 2,
          pointRadius: 2,
          backgroundColor: '#FFFFFF00',
          borderColor: '#E2782F',
          pointBorderColor: '#E2782F',
          pointBackgroundColor: '#E2782F',
          data: res.data.data
        };
        if (res.data.detailed_view) {
          res.data.detailed_view.forEach((userData, i) => {
            newChartData.datasets.push({
              label: userData.email,
              lineTension: 0.2,
              borderWidth: 2,
              pointRadius: 2,
              backgroundColor: '#E2782F99',
              borderColor: '#E2782F99',
              pointBorderColor: '#E2782F99',
              pointBackgroundColor: '#E2782F99',
              borderDash: [(i+1)*2, i+1],
              data: userData.data
            });
          });
        }
        this.chartdata = newChartData;
      }, () => {
        this.usage_grapph_loading = false;
      });
    },

    getCurrentSubscription() {
      return this.$store
          .dispatch("dashboard/getCurrentSubscription")
          .then((res) => {
            this.subscription = res.data.subscriptions[0];
          }, console.error);
    },

    getUTCDateString(timestamp) {
      return getDateUTCString(new Date(timestamp * 1000));
    },

    reload() {
      this.$router.go();
    },

    executeRequestClicked() {
      this.$gtag.event(constants.ANALYTICS_EVENTS.EXECUTE_REQUEST, {
        event_category: constants.ANALYTICS_EVENTS.DEFAULT_CATEGORY,
      });
      this.request_dialog_result = "";
      this.request_cost = 0;
      this.show_result_dialog = true;
      this.result_loading = true;
      return this.$store
          .dispatch("dashboard/getRequestResult", {
            apiKey: this.api_token,
            generatorData: this.request_generator,
          })
          .then(
              (res) => {
                this.result_loading = false;
                this.raw_result = res.data;
                this.request_dialog_result = typeof res.data === 'object' ? JSON.stringify(res.data, null, 4) : res.data;
                this.request_cost = res.headers['ant-credits-cost'] ? parseInt(res.headers['ant-credits-cost']) : 0;
                this.getCurrentSubscription();
              },
              (err) => {
                this.result_loading = false;
                this.raw_result = err.response.data;
                this.request_dialog_result =
                    err?.response?.data ? JSON.stringify(err.response.data, null, 4) : "Something went wrong. Please, try again";
              }
          );
    },
    async clipboardForOutput(output) {
      // convert output to string if it's an object
      if (typeof output === 'object') {
        output = JSON.stringify(output);
      }
      await navigator.clipboard.writeText(output);
      this.$notify({
        group: "main",
        text: "Copied to clipboard!",
        duration: 500,
      });
    },
    onCopiedToClipboard({ value }) {
      console.log("success", value);
      this.$notify({
        group: "main",
        text: "Copied to clipboard!",
        duration: 500,
      });
    },
    onUpdatePaymentDetailsClicked() {
      // eslint-disable-next-line no-undef
      Paddle.Checkout.open({
        override: this.subscription.update_url,
        successCallback: () => {
          // TODO: add logging for tracking
        },
        closeCallback: () => {
          // TODO: add logging for tracking
        },
      });
    },
    getAPIRenewStatus() {
      return this.$store
          .dispatch("dashboard/getAPIRenewStatus")
          .then((res) => {
            this.api_renew_status = res.auto_prolong_web_scraping_api;
          }, console.error);
    },
    onChangeRenewStatusClicked() {
      this.$store
          .dispatch("dashboard/updateSubscriptionRenewStatus", {
            auto_prolong_web_scraping_api: !this.api_renew_status,
          })
          .then(() => {
            this.api_renew_status = !this.api_renew_status;
          });
    },
  },
  mounted() {
    this.loading = true;
    Promise.all([
      this.getToken(),
      this.getCurrentSubscription(),
      this.getAPIRenewStatus(),
    ]).then(
        () => (this.loading = false),
        () => (this.loading = false)
    );
    this.getUsageGraph();
    const randomDoc = constants.RANDOM_STRINGS_TO_ENDORSE_DOCUMENTATION_READING[
        Math.floor(Math.random() * constants.RANDOM_STRINGS_TO_ENDORSE_DOCUMENTATION_READING.length)
        ];

    this.doc_content = randomDoc.content;
    this.doc_title = randomDoc.title;
    this.doc_icon = randomDoc.icon;
  },
};
</script>

<style scoped>
.md-card {
  margin: 15px;
}

.md-dialog-container {
  width: 50%;
  height: 75%;
}

pre[class*="language-"] {
  max-height: 30em;
  border-radius: 2px;
  background-color: #f7f7f7;
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),
  0 1px 5px 0 rgba(0, 0, 0, 0.12);
}

.execution-notice {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100px;
  width: 100%;
  height: 75%;
}

.execution-spinner {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 100px;
}
</style>
